module.exports = __webpack_public_path__ + "img/37106-052.81cfc029.jpg";